/**
 * documentSets constants
 */
export const DOCUMENT_SETS_LOAD_REQUESTED = 'DOCUMENT_SETS_LOAD_REQUESTED';
export const DOCUMENT_SETS_LOAD_SUCCEEDED = 'DOCUMENT_SETS_LOAD_SUCCEEDED';
export const DOCUMENT_SETS_LOAD_FAILED = 'DOCUMENT_SETS_LOAD_FAILED ';
export const DOCUMENT_SETS_LOAD_CANCELED = 'DOCUMENT_SETS_LOAD_CANCELED ';

export const DOCUMENT_SET_LOAD_REQUESTED = 'DOCUMENT_SET_LOAD_REQUESTED';
export const DOCUMENT_SET_LOAD_SUCCEEDED = 'DOCUMENT_SET_LOAD_SUCCEEDED';
export const DOCUMENT_SET_LOAD_FAILED = 'DOCUMENT_SET_LOAD_FAILED ';

export const DOCUMENT_SETS_SET = 'DOCUMENT_SETS_SET';
export const DOCUMENT_SETS_MERGE = 'DOCUMENT_SETS_MERGE';
export const DOCUMENT_SET_SET = 'DOCUMENT_SET_SET';

export const DOCUMENT_SET_DELETE_REQUESTED = 'DOCUMENT_SET_DELETE_REQUESTED';
export const DOCUMENT_SET_DELETE_SUCCEEDED = 'DOCUMENT_SET_DELETE_SUCCEEDED';
export const DOCUMENT_SET_DELETE_FAILED = 'DOCUMENT_SET_DELETE_FAILED';

export const DOCUMENT_SET_LOAD_NAMESPACE = 'DOCUMENT_SET_LOAD';
